import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ep_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/")) {
      localStorage.removeItem("ep_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function dmy(v) {
  const s = String(v || "").replace(/-/g, "");
  return /^\d{8}$/.test(s) ? `${s.slice(6, 8)}/${s.slice(4, 6)}/${s.slice(0, 4)}` : v || "";
}

export function x12Date(v) {
  if (!v) return "—";
  return dmy(v);
}

export function ts(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "");
}

export const EDI_NAMES = {
  850: "Purchase Order",
  940: "Warehouse Shipping Order",
  945: "Warehouse Shipping Advice",
  861: "Receiving Advice",
  856: "Advance Ship Notice",
  997: "Functional Acknowledgement",
};

export const ediName = (code) => (EDI_NAMES[code] ? `${code} ${EDI_NAMES[code]}` : code);

export const fmtNum = (n) => (n == null ? "—" : Number(n).toLocaleString("en-GB"));
